import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import ProcessSteps from '@/components/ProcessSteps';
import GoogleReviews from '@/components/GoogleReviews';
import AppointmentBooking from '@/components/AppointmentBooking';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';

const Index = () => {
  useEffect(() => {
    const shouldGo = window.location.hash === '#afspraak' || sessionStorage.getItem('goAfspraak') === '1';
    if (shouldGo) {
      try { sessionStorage.removeItem('goAfspraak'); } catch {}
      setTimeout(() => {
        const el = document.getElementById('afspraak');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
          setTimeout(() => {
            const link = el.querySelector('a[href="#"]') as HTMLAnchorElement | null;
            link?.click();
          }, 800);
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Compleet Verzekerd - Persoonlijk Verzekeringsadvies</title>
        <meta name="description" content="Compleet Verzekerd - Persoonlijk verzekeringsadvies in Dordrecht. Auto, woning, hypotheek en zakelijke verzekeringen. Gratis afspraak. ☎ 078-220 00 21" />
        <meta name="keywords" content="verzekeringen dordrecht, verzekeringsadvies, autoverzekering, woonhuisverzekering, hypotheekadvies, zakelijke verzekeringen, persoonlijk advies, compleet verzekerd" />
        <link rel="canonical" href="https://compleetverzekerd.nl/" />
        <link rel="preload" as="image" imageSrcSet="/assets/hero-insurance-DvlqwLxL.webp 1335w, /assets/hero-insurance-BPpKXmh1.jpg 1335w" imageSizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1335px" />
        <link rel="preload" as="image" href="/assets/7e3512ca-fe6e-49ba-8835-eea810c01d25.png" />
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Compleet Verzekerd",
            "description": "Persoonlijk, transparant en deskundig verzekeringsadvies",
            "url": "https://compleetverzekerd.nl",
            "telephone": "+31782200021",
            "email": "info@compleetverzekerd.nl",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Van Eesterenplein 95",
              "addressLocality": "Dordrecht",
              "postalCode": "3315 KT",
              "addressCountry": "NL"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "51.8036555",
              "longitude": "4.7179614"
            },
            "openingHours": "Mo-Fr 08:30-17:30",
            "priceRange": "$",
            "serviceArea": {
              "@type": "City",
              "name": "Dordrecht"
            }
          }`}
        </script>
      </Helmet>
      {/* Skip link for keyboard users */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded"
      >
        Spring naar hoofdinhoud
      </a>
      
      <Header />
      
      <main id="main-content">
        <Hero />
        <ProcessSteps />
        <GoogleReviews />
        <AppointmentBooking />
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
